import React, { useEffect } from 'react';
import { AssignKnowledgeBaseListItem } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/AssignKnowledgeBasePopup/AssignKnowledgeBaseListItem';
import { useParams } from 'react-router-dom';

export const AssignKnowledgeBaseList = ({ knowledgeBases }) => {
  if (!knowledgeBases?.length) {
    return null;
  }

  return (
    <div className={'flex flex-col w-full'}>
      <div className={'pb-4 px-4'}>
        <label className={'font-bold text-ebony text-sm'}>Current knowledge bases</label>
      </div>
      <div>
        <ul className={'list-none w-full p-0 m-0 flex flex-col gap-4 max-h-64 overflow-auto px-4'}>
          {knowledgeBases.map((kb) => {
            return <AssignKnowledgeBaseListItem key={kb.id} knowledgeBase={kb} />;
          })}
        </ul>
      </div>
    </div>
  );
};
